/** @format */

import { min } from "moment";
import * as yup from "yup";

const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

// =================================================================================

const emailSchema = yup.object().shape({
  email: yup
    .string()
    .matches(regexEmail, "Email không hợp lệ")
    .required("Yêu cầu nhập email"),
});

const loginSchema = yup.object().shape({
  email: yup
    .string()
    // .matches(regexEmail, "Email không hợp lệ")
    .required("Yêu cầu nhập email"),
  password: yup
    .string()
    .min(6, "Mật khẩu tối thiểu 6 ký tự")
    .required("Yêu vầu nhập mật khẩu"),
  checked: yup.boolean(),
});

export const taskCreateSchema = yup.object().shape({
  title: yup.string().required("Yêu cầu nhập tên"),
  description: yup.string().required("Yêu cầu nhập mô tả"),
  start_date: yup.string().nullable(),
  due_date: yup.string().nullable(),
  status: yup.string().required("Trạng thái là bắt buộc"),
  spent_time: yup.number().nullable(),
  progress: yup.number().nullable(),
  priority: yup.string(),
  est_time: yup.number().nullable(),
  assignee_id: yup.number().required("Người phụ trách là bắt buộc"),
  sprint_id: yup.number().nullable(),
});

export const projectCreateSchema = yup.object().shape({
  name: yup.string().required("Yêu cầu nhập tên"),
  description: yup.string().required("Yêu cầu nhập mô tả"),
  content: yup.string().required("Yêu cầu nhập nội dung"),
  start_date: yup.string().nullable(),
  due_date: yup.string().nullable(),
  avatar: yup.mixed().nullable(),
  status: yup.string().required("Trạng thái là bắt buộc"),
  members: yup.array()
});

const registerSchema = yup.object().shape({
  email: yup
    .string()
    .matches(regexEmail, "Email không hợp lệ")
    .required("Yêu cầu nhập email"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/\d/, "Password must contain at least one number")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords must match")
    .required("Confirm Password is required"),
  acceptPrivacy: yup
    .boolean()
    .oneOf([true], "You must accept the privacy policy"),
  subscribeEmail: yup.boolean(),
});

const dynamicSchema = (isOtpStep: boolean) =>
  yup.object().shape({
    email: isOtpStep
      ? yup.string().matches(regexEmail, "Invalid email format")
      : yup
        .string()
        .matches(regexEmail, "Invalid email format")
        .required("Email is required"),
    otp: isOtpStep
      ? yup
        .string()
        .length(6, "OTP must be exactly 6 digits")
        .required("OTP is required")
      : yup.string().notRequired(),
  });

const resetPassSchema = yup.object().shape({
  newPassword: yup
    .string()
    .min(8, "New password must be at least 8 characters")
    .required("New password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), ""], "Passwords must match")
    .required("Confirm Password is required"),
});

const updatePassSchema = yup.object().shape({
  oldPassword: yup.string().required("Old password is required"),
  newPassword: yup
    .string()
    .min(8, "New password must be at least 8 characters")
    .required("New Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), ""], "Passwords must match")
    .required("Confirm Password is required"),
});

const profileSchema = yup.object().shape({
  userName: yup.string().required("User name must be not empty"),
  avatar: yup.string().notRequired(),
  email: yup.string().notRequired(),
});

const otpSchema = yup.object().shape({
  code: yup
    .string()
    .required("Otp is required")
    .length(6, "OTP must be exactly 6 characters"),
});

export {
  dynamicSchema,
  loginSchema,
  otpSchema,
  profileSchema,
  registerSchema,
  resetPassSchema,
  updatePassSchema,
  emailSchema,
};
